import type { BLOCK_TYPE } from '../enums'

import type { BlockBaseSettings, IBlock } from './base'

export enum BINARY_BLOCK_MODE {
  SWITCH = 'switch',
  CHECKBOX = 'checkbox'
}

export interface BinaryBlock extends IBlock {
  type: BLOCK_TYPE.BINARY_INPUT
  settings: BlockBaseSettings & {
    mode: BINARY_BLOCK_MODE
    default: boolean
  }
}

export type BinaryBlockValue = boolean
